import React from "react";

export default function TrustStrip() {
  const trustItems = [
    { icon: "fa-shield-alt", title: "Best Rate Guarantee", desc: "Lowest prices when booking direct" },
    { icon: "fa-credit-card", title: "Zero Booking Fee", desc: "No hidden charges or extra fees" },
    { icon: "fa-bolt", title: "Instant Confirmation", desc: "Real-time reservation booking" },
    { icon: "fa-headset", title: "24/7 Guest Support", desc: "Dedicated royal concierge team" },
  ];

  return (
    <section
      className="hk-trust-strip py-3 position-relative"
      style={{
        background: "linear-gradient(180deg, #FAF6F0 0%, #F2EAE0 50%, #FAF6F0 100%)",
        color: "#1A283B",
        borderTop: "1px solid rgba(212, 175, 55, 0.3)",
        borderBottom: "1px solid rgba(212, 175, 55, 0.25)",
        margin: 0
      }}
      aria-label="Resort Trust Guarantees"
    >
      <div className="container" style={{ maxWidth: "1140px" }}>
        <div className="row g-3 justify-content-center text-center">
          {trustItems.map((item, index) => (
            <div className="col-6 col-md-3" key={index}>
              <div className="d-flex align-items-center justify-content-center gap-2">
                <i className={`fas ${item.icon} flex-shrink-0`} style={{ fontSize: "1.2rem", color: "#FEA116" }}></i>
                <div className="text-start">
                  <strong className="d-block" style={{ fontSize: "0.85rem", letterSpacing: "0.02em", fontFamily: "'Cinzel', serif", color: "#0B1D37" }}>
                    {item.title}
                  </strong>
                  <small style={{ fontSize: "0.75rem", color: "#53647C" }}>
                    {item.desc}
                  </small>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
